module.exports = require("./crossfilter").crossfilter;



//////////////////
// WEBPACK FOOTER
// ./~/crossfilter/index.js
// module id = 119
// module chunks = 57